import Plyr from 'plyr';

window.addEventListener('DOMContentLoaded', () => {

    const videos = document.querySelectorAll('.twz-element-video--player');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                Array.from(videos).map(el => {
                    new Plyr(el)
                });
                observer.unobserve(entry.target);
            }
        });
    },{
        root: null,
        rootMargin: '0px',
        threshold: 0
    });

    if ('IntersectionObserver' in window) {
        videos.forEach(element => {
            observer.observe(element);
        });
    } else {
        // IntersectionObserver NOT Supported
        videos.map(el => new Plyr(el));
    };

});